export default "__VITE_ASSET__BsPQ6I2e__"